import { Component, OnInit } from "@angular/core";
import { ICellRendererParams } from "ag-grid-community";
import { AgRendererComponent } from "ag-grid-angular";
import { get as _get } from "lodash-es";
import { StepsBuilderHelperService } from "../connector-studio/services/steps-builder-helper/steps-builder-helper.service"
import { CacheService } from "../cache.service";
import { Token } from "../app.model";
import { getRolesFromToken } from "../shared/helpers/jwt.helper";
import { NS_Enums, NS_ConnectorStudioService } from "../shared/namespaces";
import { isEmpty as _isEmpty, intersection as _intersection, castArray as _castArray } from 'lodash-es';
@Component({
  selector: "app-menu-status-render",
  templateUrl: "./menu-status-render.component.html",
  styleUrls: ["./menu-status-render.component.scss"],
})
export class MenuStatusRenderComponent implements AgRendererComponent {
  public params: ICellRendererParams;
  status: string;
  isStudioSourcesList: boolean = false;
  isCStudioAdmin = false;

  constructor(private stepsBuilderHelperService: StepsBuilderHelperService, private cacheService: CacheService ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.status = this.params.value;
    this.isStudioSourcesList = this.params["isStudioSourcesList"];
    this.updateAccessFlag()
  }

  updateAccessFlag(){
    const userToken: Token = this.cacheService.getObject(NS_Enums.cacheKeysEnum.saras_auth_key);
    const rolesFromToken = getRolesFromToken(userToken.token);
    const userRole = rolesFromToken || userToken.role;

    this.isCStudioAdmin = !_isEmpty(_intersection(userRole, NS_ConnectorStudioService.ALLOWED_CSTUDIO_STATUS_EDIT_ROLES));
  }

  studioStatusChange(val: any) {
    this.params.context.componentParent.studioStatusChange(_get(this.params, 'data'), val, this.status)
  }

  refresh(): boolean {
    return false;
  }

}
